
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexepHxPMTBdGxLxNBvHwavPijO8TCUbi52shCGNAt64jEMeta } from "/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/index.vue?macro=true";
import { default as _91slug_93Q94NYmzU8nxWTb28WGNGqBFEFF_45tDEmzN_45YmZk3TiqMMeta } from "/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/[slug].vue?macro=true";
import { default as indexyRuXWfk7TvKU2V5jKqTz9XOwnMw1_08i7ibWua4alLkMeta } from "/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/articles/index.vue?macro=true";
export default [
  {
    name: "knowledge-hub___en",
    path: "/knowledge-hub",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/index.vue")
  },
  {
    name: "knowledge-hub___en_AU",
    path: "/en_AU/knowledge-hub",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/index.vue")
  },
  {
    name: "knowledge-hub___pt_BR",
    path: "/pt_BR/centro-de-conhecimento",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/index.vue")
  },
  {
    name: "knowledge-hub___zh_CN",
    path: "/zh_CN/knowledge-hub",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/index.vue")
  },
  {
    name: "knowledge-hub___cs_CZ",
    path: "/cs_CZ/knowledge-hub",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/index.vue")
  },
  {
    name: "knowledge-hub___da_DK",
    path: "/da_DK/videnshub",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/index.vue")
  },
  {
    name: "knowledge-hub___de_DE",
    path: "/de_DE/knowledge-hub",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/index.vue")
  },
  {
    name: "knowledge-hub___es_ES",
    path: "/es_ES/knowledge-hub",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/index.vue")
  },
  {
    name: "knowledge-hub___fr_FR",
    path: "/fr_FR/ressources",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/index.vue")
  },
  {
    name: "knowledge-hub___it_IT",
    path: "/it_IT/knowledge-hub",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/index.vue")
  },
  {
    name: "knowledge-hub___ja_JP",
    path: "/ja_JP/knowledge-hub",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/index.vue")
  },
  {
    name: "knowledge-hub___es_MX",
    path: "/es_MX/centro-de-informacion",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/index.vue")
  },
  {
    name: "knowledge-hub___nl_NL",
    path: "/nl_NL/knowledge-hub",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/index.vue")
  },
  {
    name: "knowledge-hub___no_NO",
    path: "/no_NO/kunnskapshub",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/index.vue")
  },
  {
    name: "knowledge-hub___pl_PL",
    path: "/pl_PL/knowledge-hub",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/index.vue")
  },
  {
    name: "knowledge-hub___pt_PT",
    path: "/pt_PT/knowledge-hub",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/index.vue")
  },
  {
    name: "knowledge-hub___sv_SE",
    path: "/sv_SE/kunskapshubb",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/index.vue")
  },
  {
    name: "knowledge-hub___en_AE",
    path: "/en_AE/knowledge-hub",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/index.vue")
  },
  {
    name: "knowledge-hub___en_SG",
    path: "/en_SG/knowledge-hub",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/index.vue")
  },
  {
    name: "knowledge-hub___en_GB",
    path: "/en_GB/knowledge-hub",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/index.vue")
  },
  {
    name: "knowledge-hub-slug___en",
    path: "/knowledge-hub/:slug()",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/[slug].vue")
  },
  {
    name: "knowledge-hub-slug___en_AU",
    path: "/en_AU/knowledge-hub/:slug()",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/[slug].vue")
  },
  {
    name: "knowledge-hub-slug___pt_BR",
    path: "/pt_BR/centro-de-conhecimento/:slug()",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/[slug].vue")
  },
  {
    name: "knowledge-hub-slug___zh_CN",
    path: "/zh_CN/knowledge-hub/:slug()",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/[slug].vue")
  },
  {
    name: "knowledge-hub-slug___cs_CZ",
    path: "/cs_CZ/knowledge-hub/:slug()",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/[slug].vue")
  },
  {
    name: "knowledge-hub-slug___da_DK",
    path: "/da_DK/videnshub/:slug()",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/[slug].vue")
  },
  {
    name: "knowledge-hub-slug___de_DE",
    path: "/de_DE/knowledge-hub/:slug()",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/[slug].vue")
  },
  {
    name: "knowledge-hub-slug___es_ES",
    path: "/es_ES/knowledge-hub/:slug()",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/[slug].vue")
  },
  {
    name: "knowledge-hub-slug___fr_FR",
    path: "/fr_FR/ressources/:slug()",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/[slug].vue")
  },
  {
    name: "knowledge-hub-slug___it_IT",
    path: "/it_IT/knowledge-hub/:slug()",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/[slug].vue")
  },
  {
    name: "knowledge-hub-slug___ja_JP",
    path: "/ja_JP/knowledge-hub/:slug()",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/[slug].vue")
  },
  {
    name: "knowledge-hub-slug___es_MX",
    path: "/es_MX/centro-de-informacion/:slug()",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/[slug].vue")
  },
  {
    name: "knowledge-hub-slug___nl_NL",
    path: "/nl_NL/knowledge-hub/:slug()",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/[slug].vue")
  },
  {
    name: "knowledge-hub-slug___no_NO",
    path: "/no_NO/kunnskapshub/:slug()",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/[slug].vue")
  },
  {
    name: "knowledge-hub-slug___pl_PL",
    path: "/pl_PL/knowledge-hub/:slug()",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/[slug].vue")
  },
  {
    name: "knowledge-hub-slug___pt_PT",
    path: "/pt_PT/knowledge-hub/:slug()",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/[slug].vue")
  },
  {
    name: "knowledge-hub-slug___sv_SE",
    path: "/sv_SE/kunskapshubb/:slug()",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/[slug].vue")
  },
  {
    name: "knowledge-hub-slug___en_AE",
    path: "/en_AE/knowledge-hub/:slug()",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/[slug].vue")
  },
  {
    name: "knowledge-hub-slug___en_SG",
    path: "/en_SG/knowledge-hub/:slug()",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/[slug].vue")
  },
  {
    name: "knowledge-hub-slug___en_GB",
    path: "/en_GB/knowledge-hub/:slug()",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/[slug].vue")
  },
  {
    name: "knowledge-hub-articles___en",
    path: "/knowledge-hub/articles",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/articles/index.vue")
  },
  {
    name: "knowledge-hub-articles___en_AU",
    path: "/en_AU/knowledge-hub/articles",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/articles/index.vue")
  },
  {
    name: "knowledge-hub-articles___pt_BR",
    path: "/pt_BR/centro-de-conhecimento/articles",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/articles/index.vue")
  },
  {
    name: "knowledge-hub-articles___zh_CN",
    path: "/zh_CN/knowledge-hub/articles",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/articles/index.vue")
  },
  {
    name: "knowledge-hub-articles___cs_CZ",
    path: "/cs_CZ/knowledge-hub/articles",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/articles/index.vue")
  },
  {
    name: "knowledge-hub-articles___da_DK",
    path: "/da_DK/videnshub/artikler",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/articles/index.vue")
  },
  {
    name: "knowledge-hub-articles___de_DE",
    path: "/de_DE/knowledge-hub/articles",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/articles/index.vue")
  },
  {
    name: "knowledge-hub-articles___es_ES",
    path: "/es_ES/knowledge-hub/articles",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/articles/index.vue")
  },
  {
    name: "knowledge-hub-articles___fr_FR",
    path: "/fr_FR/ressources/articles",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/articles/index.vue")
  },
  {
    name: "knowledge-hub-articles___it_IT",
    path: "/it_IT/knowledge-hub/articles",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/articles/index.vue")
  },
  {
    name: "knowledge-hub-articles___ja_JP",
    path: "/ja_JP/knowledge-hub/articles",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/articles/index.vue")
  },
  {
    name: "knowledge-hub-articles___es_MX",
    path: "/es_MX/centro-de-informacion/articles",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/articles/index.vue")
  },
  {
    name: "knowledge-hub-articles___nl_NL",
    path: "/nl_NL/knowledge-hub/articles",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/articles/index.vue")
  },
  {
    name: "knowledge-hub-articles___no_NO",
    path: "/no_NO/kunnskapshub/artikler",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/articles/index.vue")
  },
  {
    name: "knowledge-hub-articles___pl_PL",
    path: "/pl_PL/knowledge-hub/articles",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/articles/index.vue")
  },
  {
    name: "knowledge-hub-articles___pt_PT",
    path: "/pt_PT/knowledge-hub/articles",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/articles/index.vue")
  },
  {
    name: "knowledge-hub-articles___sv_SE",
    path: "/sv_SE/kunskapshubb/artiklar",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/articles/index.vue")
  },
  {
    name: "knowledge-hub-articles___en_AE",
    path: "/en_AE/knowledge-hub/articles",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/articles/index.vue")
  },
  {
    name: "knowledge-hub-articles___en_SG",
    path: "/en_SG/knowledge-hub/articles",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/articles/index.vue")
  },
  {
    name: "knowledge-hub-articles___en_GB",
    path: "/en_GB/knowledge-hub/articles",
    component: () => import("/opt/build/repo/website/knowledge-hub/pages/knowledge-hub/articles/index.vue")
  }
]